module.exports = "/_next/static/images/Frame-258be4040cc78db63e86f6bacc3323fc.webp";